//shipping fees reducer
import { 
    FETCH_SHIPPING_FEES_REQUEST,
    FETCH_SHIPPING_FEES_SUCCESS,
    FETCH_SHIPPING_FEES_FAILURE
} from '../actions/ShippingFeesActions';

const initialState = {
    shippingFees: [],
    loading: false,
    error: null
}

const shippingFeesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHIPPING_FEES_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SHIPPING_FEES_SUCCESS:
            return { ...state, shippingFees: action.payload, loading: false, error: null };
        case FETCH_SHIPPING_FEES_FAILURE:
            return { ...state, shippingFees: [], loading: false, error: action.payload };
        default:
            return state;
    }
}

export default shippingFeesReducer;
